import { useState } from 'react';
import Logo from '../../components/Logo/Logo';
import request from '../../utils/APIHelper/request';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import classNames from 'classnames';
import loadingGif from '../../assets/Other/loading.gif';
import { setCurrentUser, setJwt } from '../../utils/Auth/auth';
import { toast } from 'react-toastify';

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState('');

  const signIn = async () => {
    setLoading(true);
    if (password.length > 0 && email.length > 0) {
      const result = await request({
        url: `${controllers.auth}signIn`,
        type: requestTypes.post,
        body: { email, password },
        setLoading,
        disableLogOut: true,
      });

      if (
        result?.code !== responseTypes.error &&
        !(!result?.user || !result?.jwt)
      ) {
        setCurrentUser(result?.user);
        setJwt(result?.jwt);
      } else {
        toast.error(
          result?.message || 'Something went wrong trying to sign in!',
          {
            autoClose: 2000,
          },
        );
      }
    }
  };
  return (
    <>
      <div className="w-[100px] mx-auto  mt-10 mb-5">
        <Logo />
      </div>
      <div className="flex flex-col w-1/5 min-w-[300px] mx-auto p-5  rounded-[15px]">
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border-b-[1px] border-blue-800 px-4 mb-5 focus:outline-none focus:border-b-[1px] focus:border-blue-400"
          placeholder="your@example.com"
          type="text"
        />
        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border-b-[1px] border-blue-800 px-4 mb-5 focus:outline-none focus:border-b-[1px] focus:border-blue-400 relative"
          type="password"
          placeholder="Password..."
        />
        <div
          onClick={signIn}
          className={classNames(
            'mt-5 text-white bg-red-800 w-1/2 mx-auto rounded-xl cursor-pointer hover:bg-red-900',
            loading ? 'hidden' : null,
            email.length > 0 && password.length > 0
              ? 'cursor-pointer hover:bg-red-900 bg-red-800'
              : ' bg-gray-400',
          )}
        >
          SIGN IN
        </div>
        <div
          className={classNames(
            'w-full flex justify-center items-center',
            !loading ? 'hidden' : null,
          )}
        >
          <img className="w-8 h-8" src={loadingGif} />
        </div>
      </div>
    </>
  );
};

export default SignIn;
